export class ConfigurationSettings {   
    public hostUrl = ''; 
    public hilUrl = '';        
    public userRole: string = '';    
    public idaas_response_type = 'code';    
    public idaas_grant_type = 'authorization_code';    
    public user_api_endpoint = this.hostUrl + '/api/User';
    public auth_api_endpoint = this.hostUrl + '/api/Token';
    public botregistration_api_endpoint = this.hostUrl + '/api/BotRegistration';
    public proactivenotification_api_endpoint = this.hostUrl + '/api/ProactiveNotification';
    public botconfiguration_api_endpoint = this.hostUrl + '/api/botconfiguration';
    public userfileUpload_api_endpoint = this.hostUrl + '/api/UserFileUpload';
    public broadcast_api_endpoint = this.hostUrl + '/api/Broadcast';
    public agent_history_api_endpoint=this.hostUrl+'/api/AgentSession';
}
